// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"592":"5560a3ae","656":"0e2973d0"}[chunkId] + ".chunk.css";
};